import * as type from "./type";
import {handleActions} from "redux-actions";

export const initialState = {
    imageVersionList: [],
    selectedImageVersions: []
}

const isMatchedWithCurrentlySelectedImageVersion = (selectedImageVersionFromState, selectedImageVersionFromPayload) => {
    return selectedImageVersionFromState.preCheckinPhotoIndex === selectedImageVersionFromPayload.preCheckinPhotoIndex;
}

export default handleActions(
    {
        [type.SET_SELECTED_IMAGE_VERSIONS]: (state, action) => {
            let selectedImageVersions = state.selectedImageVersions ? state.selectedImageVersions : action.payload.selectedImageVersions;

            let matched = false;
            for (let i in selectedImageVersions) {
                matched = isMatchedWithCurrentlySelectedImageVersion(selectedImageVersions[i], action.payload.selectedImageVersions[0]);
                if (matched) {
                    selectedImageVersions[i].imageVersionIndexInGallery = action.payload.selectedImageVersions[0].imageVersionIndexInGallery;
                }
            }
            if (!matched) {
                selectedImageVersions.push(action.payload.selectedImageVersions[0]);
            }

            return {
                ...state,
                selectedImageVersions,
            }
        },
    },
    initialState
)



// WEBPACK FOOTER //
// ./src/modules/customer/state/task-widget/reducer.js